/** for drawing buttons to toggle on/off groups of models (e.g. target / rotated / actual balls) */

export interface ITVGroupDefinition {
  name: string;
  sort: number;
  color: string;
}

export const GROUP_TARGET: ITVGroupDefinition = {
  sort: 0,
  name: 'Target',
  // red
  color: '#FF0000',
};

export const GROUP_ACTUAL: ITVGroupDefinition = {
  sort: 1,
  name: 'Actual',
  // yellow
  color: '#ffc107',
};

export const GROUP_AVG_ROTATED: ITVGroupDefinition = {
  sort: 2,
  name: 'Avg. Rotated',
  // darker green
  color: '#1ac661',
};

export const GROUP_ROTATED: ITVGroupDefinition = {
  sort: 3,
  name: 'Rotated',
  // lighter green
  color: '#004411',
};
